import React, { useEffect } from 'react';
import Content from '../../../components/Pages/Dashboard';
import MainGuidanceLayout from '../../../components/Layout/Main';

interface PreviewDashboard {
  primaryColor: string;
  secondaryColor: string;
}
function PreviewDashboard({ primaryColor, secondaryColor }: PreviewDashboard) {
  useEffect(() => {
    const guidanceContainer = document.getElementById('guidance');

    if (guidanceContainer) {
      guidanceContainer.style.setProperty('--primary', primaryColor);
      guidanceContainer.style.setProperty('--secondary', secondaryColor);
    }
  }, [primaryColor, secondaryColor]);

  return (
    // overflow-y-auto removes bugged max height of PageHeader
    // "w-min child:max-h-[320px] child:overflow-y-auto" / overflow-y-auto
    <div className="pointer-events-none w-min child:max-h-[320px]">
      <MainGuidanceLayout>
        <Content previewMode />
      </MainGuidanceLayout>
    </div>
  );
}

export default PreviewDashboard;
